import { useFocusRing } from '@react-aria/focus';
import React, { useRef, useMemo } from 'react';
import { useRadio } from '@react-aria/radio';
import { mergeProps, useId } from '@react-aria/utils';
import { useHover } from '@react-aria/interactions';
import { EnableVisuallyHidden, VisuallyHidden, } from '../visually-hidden/index.js';
import { RadioButtonInputElement, RadioButtonParagraphElement, RadioButtonDescriptionElement, } from './radio-group.styles.js';
import { useRadioGroupContext } from './radio-group-context.component.js';
import { ChipRadioButton } from './radio-button-variants/chip-radio-button.component.js';
import { StandardRadioButton } from './radio-button-variants/standard-radio-button.component.js';
export const RadioButton = React.forwardRef(({ children, dataAutomation, description, startIcon, lang, className, style, ...props }, ref) => {
    const { state, variant } = useRadioGroupContext();
    const radioRef = useRef(null);
    const { inputProps, isDisabled, isSelected } = useRadio({ ...props, children }, state, radioRef);
    const { isFocused, isFocusVisible, focusProps } = useFocusRing();
    const interactionDisabled = isDisabled || state.isReadOnly;
    const { hoverProps, isHovered } = useHover({
        isDisabled: interactionDisabled,
    });
    const uniqueDataAutomation = useMemo(() => dataAutomation ||
        ['radio-button', props.id || ''].filter(Boolean).join('-'), [dataAutomation, props.id]);
    const labelId = useId();
    const descriptionId = useId();
    const RadioButtonElement = variant === 'chips' ? ChipRadioButton : StandardRadioButton;
    return (React.createElement(React.Fragment, null,
        React.createElement(RadioButtonElement, { ref: ref, isSelected: isSelected, isDisabled: isDisabled, isHovered: isHovered, isFocused: isFocused, isFocusVisible: isFocusVisible, dataAutomation: uniqueDataAutomation, lang: lang, className: className, style: style, ...hoverProps },
            React.createElement(VisuallyHidden, null,
                React.createElement(RadioButtonInputElement, { ...mergeProps(inputProps, focusProps), ref: radioRef, "data-automation": `${uniqueDataAutomation}/input/${isSelected ? 'active' : 'inactive'}`, "aria-labelledby": labelId, "aria-describedby": description ? descriptionId : undefined })),
            React.createElement(RadioButtonParagraphElement, { id: labelId, startIcon: startIcon }, children),
            description && (React.createElement(EnableVisuallyHidden, { isEnabled: variant === 'chips' },
                React.createElement(RadioButtonDescriptionElement, { id: descriptionId }, description))))));
});
//# sourceMappingURL=radio-button.component.js.map